import React from 'react';

class DeviceRevoked extends React.Component {
  render = () => {
    const status = this.props.status;
    const individualId = this.props.individualId;
    if (status === null || status === 'activate' || status === 'play') {
      return (<div></div>);
    }
    if (status === 'revoked') {
      const style = {
        position: 'absolute',
        top: '0',
        left: '0',
        width:'100%',
        height:'100%',
        padding:'36px',
        backgroundColor: '#eee'
      };
      return (
        <div style={style}>
          <h3>許可されていないクライアントです。</h3>
          <p>使用制限を設けております。<br/>
          TVMockを利用するには、認証サーバで制限解除が必要です。<br/>
          問合せIDをお知らせください。</p>
          <hr/>
          <p>問合せID: {individualId}</p>
        </div>
      );
    }
    return (
        <div className="status">{status}</div>
    );
  };
};

export default DeviceRevoked;



// WEBPACK FOOTER //
// ./src/components/DeviceRevoked.js